import * as React from 'react';

import BaseIcon from 'shared/components/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const SetCellGoogleSheetsIcon: React.FC<CommonIconProps> = (
  props: CommonIconProps
) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{
        viewBox: '0 0 24 24'
      }}
      {...props}
    >
      <path
        d="M2.40002 2.4C2.40002 1.07452 3.47454 0 4.80002 0H14.4L21.6 7.2V21.6C21.6 22.9255 20.5255 24 19.2 24H4.80002C3.47454 24 2.40002 22.9255 2.40002 21.6V2.4Z"
        fill="#129A5A"
      />
      <path
        opacity="0.3"
        d="M14.4 0L21.6 7.2H16.8C15.4745 7.2 14.4 6.12548 14.4 4.8V0Z"
        fill="white"
      />
      <path
        d="M12 18.3997L12 10.3996M12 10.3996L9 13.3996M12 10.3996L15 13.3996"
        stroke="white"
        strokeWidth="1.00001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default SetCellGoogleSheetsIcon;
